// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Db from "../../backend/Db.bs.jsx";
import * as Rxjs from "../../Rxjs.bs.jsx";
import * as Rxjs$1 from "rxjs";
import * as React from "react";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as DateUtils from "../../utils/DateUtils.bs.jsx";
import * as UserRoles from "../../backend/UserRoles.bs.jsx";
import * as Reactfire from "reactfire";
import * as PlaceHeader from "../../components/PlaceHeader/PlaceHeader.bs.jsx";
import * as Auth from "rxfire/auth";
import * as PersonDetail from "./PersonDetail.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_JsError from "@rescript/runtime/lib/es6/Stdlib_JsError.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Firestore from "rxfire/firestore";
import * as FormattedCurrency from "../../components/FormattedCurrency/FormattedCurrency.bs.jsx";
import * as SectionWithHeader from "../../components/SectionWithHeader/SectionWithHeader.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as FormattedRelativeTime from "../../components/FormattedRelativeTime/FormattedRelativeTime.bs.jsx";
import * as PersonAddPersonsSetting from "./PersonAddPersonsSetting.bs.jsx";
import PlacePersonsSettingModuleCss from "./PlacePersonsSetting.module.css";

let classes = PlacePersonsSettingModuleCss;

function pageDataRx(auth, firestore, placeId) {
  let placeRef = Db.placeDocument(firestore, placeId);
  let placeRx = Rxjs.op(Firestore.docData(placeRef, { "idField": "uid" }), Rxjs.keepSome);
  let allChargedKegsRx = Db.allChargedKegsRx(firestore, placeId);
  let unfinishedConsumptionsByUserRx = Rxjs.op(allChargedKegsRx, Rxjs$1.map((chargedKegs, param) => {
    let consumptionsByUser = new Map();
    chargedKegs.forEach(keg => {
      Db.groupKegConsumptionsByUser(consumptionsByUser, keg);
    });
    consumptionsByUser.forEach(consumptions => {
      consumptions.sort((a, b) => DateUtils.compare(a.createdAt, b.createdAt));
    });
    return consumptionsByUser;
  }));
  let pendingTransactionsByUserRx = Rxjs.op(allChargedKegsRx, Rxjs$1.map((chargedKegs, param) => {
    let kegByDonor = new Map();
    chargedKegs.forEach(keg => {
      Object.entries(keg.donors).forEach(param => {
        let personId = param[0];
        let transaction_amount = param[1];
        let transaction_createdAt = keg.createdAt;
        let transaction_keg = keg.serial;
        let transaction_note = null;
        let transaction_person = null;
        let transaction = {
          amount: transaction_amount,
          createdAt: transaction_createdAt,
          keg: transaction_keg,
          note: transaction_note,
          person: transaction_person
        };
        let kegs = kegByDonor.get(personId);
        if (kegs !== undefined) {
          kegs.push(transaction);
        } else {
          kegByDonor.set(personId, [transaction]);
        }
      });
    });
    return kegByDonor;
  }));
  let personsAllRx = Db.PersonsIndex.allEntriesSortedRx(firestore, placeId);
  let currentUserRx = Rxjs.op(Auth.user(auth), Rxjs.keepMap(prim => {
    if (prim === null) {
      return;
    } else {
      return Primitive_option.some(prim);
    }
  }));
  return Rxjs$1.combineLatest(placeRx, personsAllRx, unfinishedConsumptionsByUserRx, pendingTransactionsByUserRx, currentUserRx);
}

function PlacePersonsSetting(props) {
  let placeId = props.placeId;
  let auth = Reactfire.useAuth();
  let firestore = Reactfire.useFirestore();
  let pageDataStatus = Reactfire.useObservable(`Page_PlacePersonsSetting_` + placeId, pageDataRx(auth, firestore, placeId));
  let match = React.useState(() => "Hidden");
  let setDialog = match[1];
  let dialogState = match[0];
  let hideDialog = param => setDialog(param => "Hidden");
  let match$1 = pageDataStatus.data;
  if (match$1 === undefined) {
    return null;
  }
  let personsAll = match$1[1];
  let place = match$1[0];
  let match$2 = Stdlib_Option.getOrThrow(place.accounts[match$1[4].uid], undefined);
  let currentUserRole = match$2[0];
  if (!UserRoles.isAuthorized(currentUserRole, 80)) {
    Stdlib_JsError.throwWithMessage(`Insufficient permissions to view this page`);
  }
  let tmp;
  if (typeof dialogState !== "object") {
    tmp = dialogState === "Hidden" ? null : <PersonAddPersonsSetting.make
        existingNames={personsAll.map(param => param[1].name)}
        onDismiss={hideDialog}
        onSubmit={values => {
          Db.Person.add(firestore, placeId, values.name);
          setDialog(param => "Hidden");
        }}
      />;
  } else {
    let personId = dialogState._0;
    let currentIdx = personsAll.findIndex(param => param[0] === personId);
    if (currentIdx === -1) {
      setDialog(param => "Hidden");
      tmp = null;
    } else {
      let match$3 = personsAll[currentIdx];
      let person = match$3[1];
      let isPersonOwner = Stdlib_Option.mapOr(Stdlib_Option.flatMap(Primitive_option.fromNull(person.userId), userId => place.accounts[userId]), false, param => param[0] === 100);
      let canRename = !isPersonOwner || UserRoles.isAuthorized(currentUserRole, 100);
      let hasNext = currentIdx < (personsAll.length - 1 | 0);
      let hasPrevious = currentIdx > 0;
      let handleCycle = increase => {
        let allowed = increase ? hasNext : hasPrevious;
        if (!allowed) {
          return;
        }
        let nextIdx = currentIdx + (
          increase ? 1 : -1
        ) | 0;
        let match = Stdlib_Option.getOrThrow(personsAll[nextIdx], undefined);
        let nextPersonId = match[0];
        setDialog(param => ({
          TAG: "PersonDetail",
          _0: nextPersonId
        }));
      };
      let unfinishedConsumptions = Stdlib_Option.getOr(match$1[2].get(personId), []);
      tmp = <PersonDetail.make
        canRename={canRename}
        hasNext={hasNext}
        hasPrevious={hasPrevious}
        onDeletePerson={() => {
          Db.Person.$$delete(firestore, placeId, personId);
        }}
        onDismiss={hideDialog}
        onNextPerson={() => handleCycle(true)}
        onPreviousPerson={() => handleCycle(false)}
        pendingTransactions={Stdlib_Option.getOr(match$1[3].get(personId), [])}
        person={person}
        personsAll={personsAll}
        personId={personId}
        place={place}
        placeId={placeId}
        unfinishedConsumptions={unfinishedConsumptions}
      />;
    }
  }
  return <FormattedCurrency.Provider.make
    value={place.currency}
  >
    <div
      className={Styles.page.narrow}
    >
      <PlaceHeader.make
        buttonRightSlot={null}
        createdTimestamp={place.createdAt}
        placeName={place.name}
      />
      <main>
        <SectionWithHeader.make
          buttonsSlot={<button
            className={Styles.button.base}
            type={"button"}
            onClick={param => setDialog(param => "AddPerson")}
          >
            {"Přidat hosta"}
          </button>}
          headerId={"persons_accounts"}
          headerSlot={"Účetnictví"}
        >
          <table
            aria-labelledby={"persons_accounts"}
            className={Styles.table.stretch + ` ` + classes.table}
          >
            <thead>
              <tr>
                <th
                  scope={"col"}
                >
                  {"Host"}
                </th>
                <th
                  scope={"col"}
                >
                  {"Naposledy"}
                </th>
                <th
                  scope={"col"}
                >
                  {"Role"}
                </th>
                <th
                  scope={"col"}
                >
                  {"Konto"}
                </th>
              </tr>
            </thead>
            <tbody>
              {personsAll.map(param => {
                let person = param[1];
                let personId = param[0];
                return <tr
                  key={personId} 
                  onClick={param => setDialog(param => ({
                    TAG: "PersonDetail",
                    _0: personId
                  }))}
                >
                  <th
                    scope={"row"}
                  >
                    {person.name}
                  </th>
                  <td>
                    <FormattedRelativeTime.make
                      dateTime={person.recentActivityAt.toDate()}
                    />
                  </td>
                  <td>
                    {Stdlib_Option.mapOr(Stdlib_Option.map(Stdlib_Option.flatMap(Stdlib_Option.flatMap(Primitive_option.fromNull(person.userId), userId => place.accounts[userId]), param => UserRoles.roleFromInt(param[0])), UserRoles.roleI18n), null, prim => prim)}
                  </td>
                  <td>
                    <FormattedCurrency.make
                      value={person.balance}
                      format={FormattedCurrency.formatAccounting}
                    />
                  </td>
                </tr>;
              })}
            </tbody>
          </table>
        </SectionWithHeader.make>
      </main>
      {tmp}
    </div>
  </FormattedCurrency.Provider.make>;
}

let make = PlacePersonsSetting;

export {
  classes,
  pageDataRx,
  make,
}
/* classes Not a pure module */
